module.exports = __webpack_public_path__ + "mobile.eea39af0.png";